import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, Zoom, Mousewheel } from 'swiper/modules';
import LoadingImage from './LoadingImage';

const ImageModal = ({ images, onClose, initialSlide = 0, isRTL }) => (
  <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-90">
    <div className="relative px-4 w-full max-w-6xl">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-50 text-white transition-colors hover:text-gray-300"
      >
        <FontAwesomeIcon icon={faTimes} className="text-2xl" />
      </button>

      <div className="relative">
        <Swiper
          modules={[Navigation, Pagination, Autoplay, Zoom, Mousewheel]}
          dir={isRTL ? 'rtl' : 'ltr'}
          spaceBetween={0}
          slidesPerView={1}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          pagination={{
            clickable: true,
            el: '.swiper-pagination'
          }}
          loop={true}
          autoplay={{
            enabled: true,
            delay: 3000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          }}
          mousewheel={{
            enabled: true,
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 2,
          }}
          keyboard={true}
          initialSlide={initialSlide}
          className="modal-swiper"
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="flex items-center justify-center h-[80vh]">
                <LoadingImage
                  src={img}
                  alt=""
                  className="object-contain max-w-full max-h-full"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="swiper-button-prev !absolute !left-4 !text-white"></div>
        <div className="swiper-button-next !absolute !right-4 !text-white"></div>
        <div className="swiper-pagination !bottom-4"></div>
      </div>
    </div>
  </div>
);

export default ImageModal;
